/** 制片项目 · 角色 / 类型常量（对齐 production-collaboration-plan §1.1） */

export type MemberRole =
  | 'executive_producer'
  | 'producer'
  | 'director'
  | 'writer'
  | 'art_director'
  | 'storyboard'
  | 'editor'
  | 'contributor'

export const MEMBER_ROLES: MemberRole[] = [
  'executive_producer',
  'producer',
  'director',
  'writer',
  'art_director',
  'storyboard',
  'editor',
  'contributor',
]

export type ProjectType = 'short_drama' | 'comic_drama' | 'commercial' | 'other'

export const PROJECT_TYPES: ProjectType[] = ['short_drama', 'comic_drama', 'commercial', 'other']

export type StorageMode = 'local' | 'tenant_oss' | 'custom'

export type AssetStatus = 'draft' | 'ready' | 'archived'
